module.exports = __webpack_public_path__ + "static/img/redblack_th.9f48118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/redblack_th.png
// module id = ndnu
// module chunks = 1